import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useIssue } from '../../contexts/IssueContext';
import { IssuePerDayCount, IssueItem } from '../../models/issueItem';
import issueService from '../../services/issueService';
import IssueDetailHeader from './IssueDetailHeader';
import IssuePerDayTable from './IssuePerDayTable';
// import IssuePerDayHistogram from './IssuePerDayHistogram';
import IssueDetailSection from './IssueDetailSection';
import IssuePerDayHistogramRechart from './IssuePerDayHistogramRecharts';


const IssueDetailPage: React.FC = () => {
  const { issueId } = useParams<{ issueId: string }>();
  const { selectedIssue } = useIssue();

  const [errorPerDayCount, setErrorPerDayCount] = useState<string | null>(null);
  const [isLoadingPerDayCount, setIsLoadingPerDayCount] = useState<boolean>(true);
  const [issuePerdayCount, setIssuePerdayCount] = useState<IssuePerDayCount[]>([]);

  let issueToShow: IssueItem | null = selectedIssue;

  useEffect(() => {
    const fetchIssuePerDayCounts = async () => {
      setIsLoadingPerDayCount(true);
      setErrorPerDayCount(null);
      try {
        const data = await issueService.getIssuePerDayCounts(issueId || 'UNKNOWN');
        setIssuePerdayCount(data);
      } catch (err) {
        setErrorPerDayCount('Failed to load issue per day counts.');
      } finally {
        setIsLoadingPerDayCount(false);
      }
    };

    if (issueToShow && issueToShow.id.toString() === issueId) {
      if (!issuePerdayCount || issuePerdayCount.length === 0) {
        fetchIssuePerDayCounts();
      } else {
        setIsLoadingPerDayCount(false);
      }
    }
  }, [issueId, issuePerdayCount, issueToShow]);

  if (!issueToShow || isLoadingPerDayCount) {
    return <div>Loading...</div>;
  }

  if (issueToShow.id.toString() !== issueId || errorPerDayCount) {
    return <div>Issue Details not found</div>;
  }

  return (
    <div className="container mx-auto p-4">
      <IssueDetailHeader issue={issueToShow} />
      <div className="flex gap-4">
        <div className="w-[30%]">
          <IssuePerDayTable perDayCounts={issuePerdayCount} />
        </div>
        <div className="w-[70%]">
          <IssuePerDayHistogramRechart perDayCounts={issuePerdayCount} />
        </div>
      </div>
      <IssueDetailSection issue={issueToShow} />
    </div>
  );
};

export default IssueDetailPage;
